import "./Contact.css";

export default function Contact() {
  return (
    <section className="contact-page">
      <div className="container">

        {/* TITLE */}
        <div className="section-title text-center">
          <h2>Get more Information</h2>
          <p>
            We offer prompt response via telephone and email. You will receive a
            reply within 12 hours.
          </p>
        </div>

        {/* INFO CARDS */}
        <div className="info-grid">
          <a className="info-card" href="#">
            <div className="info-icon"></div>
            <div>
              <h6>Project Inquiry ›</h6>
              <p>Customized technical support to meet different requests.</p>
            </div>
          </a>

          <a className="info-card" href="#">
            <div className="info-icon"></div>
            <div>
              <h6>Contact Sales ›</h6>
              <p>Contact our sales team for products and solutions inquiries.</p>
            </div>
          </a>

          <a className="info-card" href="#">
            <div className="info-icon"></div>
            <div>
              <h6>Online Chat ›</h6>
              <p>Chat with our live agent for general inquiries now.</p>
            </div>
          </a>
        </div>

        {/* OFFICE */}
        <div className="section-title text-center mt">
          <h3>Local Office and Warehouse</h3>
          <p>
            NX operates 8 local presences worldwide to ensure smooth global
            delivery.
          </p>
        </div>

        <div className="office-grid">
        <iframe
  title="NX Optics Location"
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.665154343146!2d77.59456231534463!3d12.971598590855032!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1670c9b44e6d%3A0xf8dfc3e8517e4fe0!2sBengaluru%2C%20Karnataka!5e0!3m2!1sen!2sin!4v1700000000000"
  width="100%"
  height="420"
  style={{ border: 0 }}
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>


          <div className="office-card">
            <h5>NX OPTICS INC</h5>

            <ul>
              <li>
                <span></span>
                <div>
                  <b>Address</b>
                  <p>Lorem Ipsum is simply dummy text of the printing</p>
                </div>
              </li>

              <li>
                <span></span>
                <div>
                  <b>Phone</b>
                  <p>+1 (888) 468-9910</p>
                </div>
              </li>

              <li>
                <span></span>
                <div>
                  <b>Support</b>
                  <p>24x7 Phone Support</p>
                </div>
              </li>

              <li>
                <span></span>
                <div>
                  <b>Email</b>
                  <p>info@nxoptics.com</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* FORM */}
        <div className="section-title text-center mt">
          <h3>Have a Question?</h3>
          <p>Have a question about purchasing a product or solution?</p>
        </div>

        <div className="form-box">
          <form>
            <select>
              <option>Sales Inquiries</option>
              <option>Technical Support</option>
              <option>General Question</option>
            </select>

            <div className="form-row">
              <input placeholder="First Name" />
              <input placeholder="Last Name" />
            </div>

            <div className="form-row">
              <input placeholder="Email" />
              <input placeholder="Company" />
            </div>

            <textarea placeholder="Comments"></textarea>

            <button>Submit</button>
          </form>
        </div>

      </div>
    </section>
  );
}
